import {
  Grid, makeStyles, Paper, Typography, Container, IconButton,
  useTheme,
} from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Loading from '../../../../components/crosscutting/Loading';
import { getPackagesContractsAction } from '../../../../actions/home.action';
import { getPurchaseOrderParametersAction } from '../../../../actions/general.action';
import { getInformationAgreementAction, getManagersAction, getAppParametersContractsAction } from '../../../../actions/license.action';
import { getServicesAction } from '../../../../actions/service.action';

const getMulishText = (fontWeight, color, fontSize) => ({
  fontFamily: 'Mulish, sans-serif',
  fontSize,
  fontWeight,
  color,
});

const useStyles = makeStyles((theme) => ({
  paper: {
    background: 'linear-gradient(#FFFFFFCC, #ffffff)',
    borderRadius: '30px',
    opacity: 1,
    padding: '5px',
    marginTop: '20px',
  },
  title: {
    fontWeight: 700,
    fontSize: '34px',
    paddingTop: '32px',
    paddingLeft: '32px',
    color: theme.backOffice.contracts.title.color,
  },
  paperGroup: {
    backgroundColor: '#fff',
    marginTop: 24,
    marginBottom: 32,
    borderRadius: 10,
    border: `1px solid ${theme.home.cart.discountText.color}`,
    padding: 36,
  },
  titleFormAgreement: {
    color: theme.backOffice.contracts.titleForm.color,
    textAlign: 'left',
    letterSpacing: '0px',
    opacity: '1',
    fontWeight: 700,
    marginTop: '5px',
    fontSize: 26,
  },
  paperStyle: {
    ...getMulishText(700, theme?.backOffice?.contracts?.details?.text, '14px'),
    padding: '20px',
    boxShadow: '0px 2px 7px rgba(0, 0, 0, 0.2)',
    borderRadius: '16px',
  },
  paperItemStyle: {
    ...getMulishText(700, theme?.backOffice?.contracts?.details?.text, '14px'),
    paddingBottom: '20px',
    paddingLeft: '20px',
    boxShadow: '0px 2px 0px 0px #00000009',
  },
  sumaryStyle: {
    ...getMulishText(700, theme?.backOffice?.contracts?.details?.title, '18px'),
    marginBottom: '20px',
  },
  subtitle: {
    ...getMulishText(700, theme?.backOffice?.contracts?.details?.title, '18px'),
    marginBottom: '20px',
    marginLeft: '10px',
  },
  resultText: {
    ...getMulishText(500, theme?.backOffice?.contracts?.details?.text, '14px'),
  },
  serviceStyle: {
    ...getMulishText(700, '#000000', '14px'),
    marginBottom: '20px',
    marginTop: '20px',
  },
  titleSerive: {
    ...getMulishText(700, theme?.backOffice?.contracts?.details?.services, '14px'),
    marginBottom: '10px',
  },
}));

const AgreementDetails = (props) => {
  const classes = useStyles();
  const {
    getInformationAgreement, getInformationAgreementResponse, uniqueId, getServices,
    servicesCombo, decodedToken, permissions, gestorType, getManagers, applicationInfo,
    listPaymentTypeContracts, getAppParametersContracts, documentTypes,
    statesAndCities, listDocumentTypeContracts, getPurchaseOrderParameters,
    listCredentialDeliveryContracts, listDeviceTypeContracts, listValidityTypeContracts,
    getPackagesContracts, productType, riskOfficers, riskOfficerRole,
  } = props;
  
  const [summary, setSummary] = useState({});
  const [, setServiceNameSelected] = useState(null);
  const [product, setProduct] = useState(null);
  const [managerType, setManagerType] = useState(null);
  const [officerRisk, setOfficerRisk] = useState(null);
  const [selectInhibitList, setSelectInhibitList] = useState(false);
  const [paymentType, setPaymentType] = useState(null);
  const [documentTypeCustomer, setDocumentTypeCustomer] = useState(null);
  const [departmentCustomer, setDepartmentCustomer] = useState(null);
  const [cityCustomer, setCityCustomer] = useState(null);
  const [documentTypeSupervisor, setDocumentTypeSupervisor] = useState(null);
  const [departmentSupervisor, setDepartmentSupervisor] = useState(null);
  const [citySupervisor, setCitySupervisor] = useState(null);
  const [serviceOptions, setServiceOptions] = React.useState([]);
  const [hasFetched, setHasFetched] = useState(false);
  const [services, setServices] = useState([]);
  const theme = useTheme();

  const formatDate = (date) => (
    date ? moment(date).format('DD/MM/YYYY') : ''
  );
  const capitalizeWords = (text) => (
    text
      ? text.toLowerCase().split(' ').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
      : ''
  );
  const capitalizeWordsKeepSiglas = (text) => {
    if (!text) return '';
    return text
      .split(' ')
      .map((word, index) => {
        const isSigla = /^[a-zA-Z]\.(?:[a-zA-Z]\.)+?$/.test(word);
        if (isSigla) return word.toUpperCase();
        if (index === 0) {
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }
        return word.toLowerCase();
      })
      .join(' ');
  };
  const capitalizeOnlyFirstWord = (text) => {
    if (!text) return '';
    const lower = text.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  };
  useEffect(() => {
    if (servicesCombo.length > 0) {
      let selectedApps = [];
      Object.keys(decodedToken).forEach((key) => {
        if (key.includes('PRIVILEGE')) {
          const privileges = decodedToken[key];
          if (Array.isArray(privileges)) {
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < privileges.length; i++) {
              const privilege = privileges[i];
              if (permissions?.includes('showAllProducts')) {
                selectedApps = [];
                const apps = servicesCombo.filter(
                  (serviceItemCombo) => serviceItemCombo.isContractFullAccess === true,
                );
                if (apps.length > 0) {
                  // eslint-disable-next-line no-loop-func
                  apps.forEach((app) => {
                    if (app.name) {
                      selectedApps.push(app.name);
                    }
                  });
                }
                break;
              }
              const matchApp = privilege.match(/LICENSE_([A-Z]+)_/);
              if (matchApp && matchApp[1]) {
                selectedApps.push(matchApp[1]);
              }
            }
          }
        }
      });
      const filteredServices = servicesCombo.filter(
        (serviceItemCombo) => selectedApps.includes(serviceItemCombo.name),
      );
      const serviceOption = filteredServices.map((serviceItemCombo) => ({
        value: serviceItemCombo.value,
        label: serviceItemCombo.label,
        name: serviceItemCombo.name,
        nameContract: serviceItemCombo.nameContract,
        contractedServices: serviceItemCombo.contractedServices,
        requiresSupervision: serviceItemCombo.requiresSupervision,
      }));
      setServiceOptions(serviceOption);
    }
  }, [servicesCombo, decodedToken, permissions]);

  useEffect(() => {
    if (riskOfficerRole) {
      getManagers(riskOfficerRole, 'OFFICERS');
    }
  }, [riskOfficerRole, getManagers]);

  const getManagersCallBack = useCallback((role, type) => {
    getManagers(role, type);
  }, [getManagers]);

  useEffect(() => {
    const fetchAgreementData = async () => {
      if (!hasFetched && getInformationAgreementResponse && serviceOptions.length > 0) {
        const filteredServices = serviceOptions.find(
          (item) => item.value === getInformationAgreementResponse?.contract?.serviceName,
        );
        if (filteredServices) {
          setServiceNameSelected(filteredServices?.nameContract);
          setProduct(filteredServices?.label);
          await getManagersCallBack(`LICENSE_${filteredServices?.nameContract}_COMERCIALMANAGER`, 'MANAGERS');
          if (filteredServices?.nameContract === 'LSTINHIB') {
            setSelectInhibitList(true);
          }
          await getAppParametersContracts(filteredServices?.nameContract, 'ParametersDocumentType', 'ParametersValidityType', 'ParametersStartDate', 'ParameterMaxReassignmentQuota', 'ParameterMaxValidityAmount', 'ParameterMaxContractValidity', 'ParameterRiskOfficerRole');
          await getPackagesContracts(filteredServices?.name, true, true);
          setHasFetched(true);
        }
      }
    };
    fetchAgreementData();
  }, [getInformationAgreementResponse, serviceOptions, hasFetched,
    getAppParametersContracts, getManagersCallBack, getPackagesContracts]);

  useEffect(() => {
    const fetchAgreementData = async () => {
      if (listDocumentTypeContracts.length > 0) {
        const uniqueCountry = listDocumentTypeContracts[0].country;
        await getPurchaseOrderParameters(uniqueCountry);
      }
    };
    fetchAgreementData();
  }, [listDocumentTypeContracts, getPurchaseOrderParameters]);

  useEffect(() => {
    if (getInformationAgreementResponse) {
      const manager = gestorType.find((m) => m.value
        === getInformationAgreementResponse?.contract?.gestorService);
      setManagerType(manager?.label);
      const officerRiskValue = riskOfficers.find((m) => m.value
        === getInformationAgreementResponse?.contract?.riskOfficerId);
      setOfficerRisk(officerRiskValue?.label);
      const payment = listPaymentTypeContracts.find((p) => p.value
        === getInformationAgreementResponse?.contract?.paymentService);
      setPaymentType(payment?.label);
      const docTypeCustomer = documentTypes.find((p) => p.value
        === getInformationAgreementResponse?.customer?.documentTypeIdService);
      setDocumentTypeCustomer(docTypeCustomer?.documentTypeCode);
      const departCustomer = statesAndCities?.statesList.find((p) => p.id
        === getInformationAgreementResponse?.customer?.departmentIdService);
      setDepartmentCustomer(departCustomer?.stateName);
      const cityOfCustomer = departCustomer?.city.find((p) => p.id
        === getInformationAgreementResponse?.customer?.cityIdService);
      setCityCustomer(cityOfCustomer?.cityName);
      const docTypeSup = documentTypes.find((p) => p.value
        === getInformationAgreementResponse?.supervisor?.documentTypeIdSupervisor);
      setDocumentTypeSupervisor(docTypeSup?.documentTypeCode);
      const departSup = statesAndCities?.statesList.find((p) => p.id
        === getInformationAgreementResponse?.supervisor?.CustomDepartmentIdService);
      setDepartmentSupervisor(departSup?.stateName);
      const cityOfSup = departSup?.city.find((p) => p.id
        === getInformationAgreementResponse?.supervisor?.CustomCityIdService);
      setCitySupervisor(cityOfSup?.cityName);
      const contractedServices = getInformationAgreementResponse?.contractedServices ?? [];
      const servicesAdd = contractedServices.map((service) => ({
        credentialsDeliveryType: service.credentialsDeliveryType,
        deviceType: service.deviceTypeId,
        productService: service.packageCode,
        quantityToAddService: service.totalQuantity,
        validityAmount: service.validityPeriod,
        validityService: service.validityType,
        isUnlimited: service.isUnlimited,
        reassignmentQuota: service.reassignmentQuota,
      }));
      setServices(servicesAdd);
    }
  }, [getInformationAgreementResponse, gestorType, listPaymentTypeContracts,
    documentTypes, statesAndCities, riskOfficers]);

  useEffect(() => {
    if (getInformationAgreementResponse) {
      setSummary({
        productName: product,
        contractNumber: getInformationAgreementResponse?.contract?.contractService,
        contractStartDate: formatDate(getInformationAgreementResponse?.contract?.startDate),
        contractEndDate: formatDate(getInformationAgreementResponse?.contract?.endDate),
        gestorService: capitalizeOnlyFirstWord(managerType),
        officerRisk: capitalizeOnlyFirstWord(officerRisk),
        paymentService: paymentType,
        personTypeService: getInformationAgreementResponse?.customer?.personTypeService === 'N' ? 'Natural' : 'Jurídica',
        documentType: documentTypeCustomer,
        documentNumberService: documentTypeCustomer === 'NIT' ? `${getInformationAgreementResponse?.customer?.documentNumberService}-${getInformationAgreementResponse?.customer?.dvService}` : getInformationAgreementResponse?.customer?.documentNumberService,
        legalName: getInformationAgreementResponse?.customer?.personTypeService === 'N' ? `${capitalizeWords(getInformationAgreementResponse?.customer?.firstNameService)} ${capitalizeWords(getInformationAgreementResponse?.customer?.lastNameService)}` : capitalizeWordsKeepSiglas(getInformationAgreementResponse?.customer?.legalNameService),
        fullAddressService: getInformationAgreementResponse?.customer?.fulladdressService,
        department: capitalizeWords(departmentCustomer),
        city: capitalizeWordsKeepSiglas(cityCustomer),
        cellphoneNumber: getInformationAgreementResponse?.customer?.cellphoneNumberService,
        email: getInformationAgreementResponse?.customer?.emailService,
        documentTypeSup: documentTypeSupervisor,
        documentNumberSupervisor:
          getInformationAgreementResponse?.supervisor?.documentNumberSupervisor,
        namesSupervisor:
          capitalizeWords(getInformationAgreementResponse?.supervisor?.namesSupervisor),
        lastNameSupervisor:
          capitalizeWords(getInformationAgreementResponse?.supervisor?.lastNameSupervisor),
        fullAddressServiceSupervisor:
          getInformationAgreementResponse?.supervisor?.CustomFulladdressService,
        departmentSupervisor: capitalizeWords(departmentSupervisor),
        citySupervisor: capitalizeWordsKeepSiglas(citySupervisor),
        cellphoneNumberSupervisor:
          getInformationAgreementResponse?.supervisor?.cellphoneNumberSupervisor,
        emailSupervisor: getInformationAgreementResponse?.supervisor?.emailSupervisor,
        supervisorPosition:
          capitalizeWords(getInformationAgreementResponse?.supervisor?.supervisorPosition),
      });
    }
  }, [getInformationAgreementResponse, product, managerType, paymentType, documentTypeCustomer,
    departmentCustomer, cityCustomer, documentTypeSupervisor,
    departmentSupervisor, citySupervisor, officerRisk]);

  useEffect(() => {
    getInformationAgreement(uniqueId);
    getServices();
  }, [getInformationAgreement, getServices, uniqueId]);

  const getResultText = (text) => (
    <Typography className={classes.resultText} component="span">
      {text}
    </Typography>
  );

  /**
   * Add dot to a number for example 3000 --> 3.000
   * @param {*} number simple number
   * @returns format number
   */
  const formatNumber = (number) => {
    const exp = /(\d)(?=(\d{3})+(?!\d))/g;
    const rep = '$1,';
    return number.toString().replace(exp, rep);
  };

  const getServiceList = () => {
    if (Array.isArray(services) && services.length > 0) {
      const elements = [];

      for (let i = 0; i < services.length; i += 1) {
        const service = services[i];
        const paddingStyle = i % 2 === 0 ? { paddingLeft: '21px' } : { paddingRight: '10px' };
        elements.push(
          <Grid item xs={12} sm={6} style={paddingStyle}>
            <Paper className={classes.paperStyle}>
              <Typography className={classes.titleSerive}>
                {productType.find(
                  (productName) => productName.value === service.productService,
                )?.label || 'Desconocido'}
              </Typography>
              {'\u00A0• Cantidad: '}
              {getResultText(service.isSwitchEnabled ? 'Ilimitada' : formatNumber(service.quantityToAddService))}
              <br />
              {'\u00A0• Tipo vigencia: '}
              {getResultText(listValidityTypeContracts.find(
                (validity) => validity.value === service.validityService,
              )?.label || 'Desconocido') }
              <br />
              {'\u00A0• Vigencia: '}
              {getResultText(service?.validityAmount)}
              <br />
              {'\u00A0• Tipo de dispositivo: '}
              {getResultText(capitalizeOnlyFirstWord(listDeviceTypeContracts.find((device) => device.value === service.deviceType)?.label) || 'N/A')}
              <br />
              {'\u00A0• Tipo de entrega: '}
              {getResultText(listCredentialDeliveryContracts.find((delivery) => delivery.value === service.credentialsDeliveryType)?.label || 'N/A')}
              <br />
              {'\u00A0• Cupo reasignación: '}
              {getResultText(service?.reassignmentQuota || 'N/A')}
            </Paper>
          </Grid>,
        );
      }
      return <>{elements}</>;
    }
    return <></>;
  };
  if (!getInformationAgreementResponse || Object.keys(getInformationAgreementResponse).length === 0) {
    return <Loading />;
  }
  return (
    <Container component="main" maxWidth="lg">
      <Paper elevation={3} className={classes.paper}>
        <Typography
          color="primary"
          className={classes.title}
        >
          Convenios
        </Typography>
        <Container component="main" maxWidth="lg">
          <Paper elevation={3} className={classes.paperGroup}>
            <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                <IconButton color="primary" style={{ color: theme.palette.secondary.main }} onClick={() => window.location.reload()}>
                  <ArrowBackIosIcon />
                </IconButton>
                <Typography
                  align="left"
                  className={classes.titleFormAgreement}
                >
                  Detalle del convenio
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <br />
              <Typography className={classes.subtitle}>Información del contrato</Typography>
              <Paper className={classes.paperItemStyle}>
                {'Producto: '}
                {getResultText(summary?.productName)}
                <br />
                {'Número de oportunidad: '}
                {getResultText(summary?.contractNumber)}
                <br />
                {'Fecha inicio: '}
                {getResultText(summary?.contractStartDate)}
                <br />
                {'Fecha fin: '}
                {getResultText(summary?.contractEndDate)}
                <br />
                {'Gestor operativo: '}
                {getResultText(summary?.gestorService)}
                <br />
                {selectInhibitList && (
                  <>
                    {'Oficial de riesgo: '}
                    {getResultText(summary?.officerRisk)}
                    <br />
                  </>
                )}
                {'Condición de pago: ' }
                {getResultText(summary?.paymentService)}
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <br />
              <Typography className={classes.subtitle}>Información del cliente</Typography>
              <Paper className={classes.paperItemStyle}>
                {'Tipo de persona: '}
                {getResultText(summary?.personTypeService)}
                <br />
                {'Tipo de identificación: '}
                {getResultText(summary?.documentType)}
                <br />
                {'No. identificación: '}
                {getResultText(summary?.documentNumberService)}
                <br />
                {summary?.personTypeService === 'Jurídica' ? 'Razón social: ' : 'Nombres y apellidos: ' }
                {getResultText(summary?.legalName)}
                <br />
                {applicationInfo?.labelStreet ? `${applicationInfo?.labelStreet}: ` : 'Dirección:' }
                {getResultText(summary?.fullAddressService)}
                <br />
                {applicationInfo?.labelRegion ? `${applicationInfo?.labelRegion}: ` : 'Departamento:' }
                {getResultText(summary?.department)}
                <br />
                { applicationInfo?.labelCity ? `${applicationInfo?.labelCity}: ` : 'Ciudad: ' }
                {getResultText(summary?.city)}
                <br />
                {'Teléfono / Celular: ' }
                {getResultText(summary?.cellphoneNumber)}
                <br />
                {'Correo electrónico: ' }
                {getResultText(summary?.email)}
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <br />
              <Typography className={classes.subtitle}>Información del supervisor</Typography>
              <Paper className={classes.paperItemStyle}>
                {'Tipo de identificación: '}
                {getResultText(summary?.documentTypeSup)}
                <br />
                {'No. identificación: '}
                {getResultText(summary?.documentNumberSupervisor)}
                <br />
                {'Nombres: '}
                {getResultText(summary?.namesSupervisor)}
                <br />
                {'Apellidos: ' }
                {getResultText(summary?.lastNameSupervisor)}
                <br />
                {applicationInfo?.labelStreet ? `${applicationInfo?.labelStreet}: ` : 'Dirección: ' }
                {getResultText(summary?.fullAddressServiceSupervisor)}
                <br />
                {applicationInfo?.labelRegion ? `${applicationInfo?.labelRegion}: ` : 'Departamento: ' }
                {getResultText(summary?.departmentSupervisor)}
                <br />
                { applicationInfo?.labelCity ? `${applicationInfo?.labelCity}: ` : 'Ciudad: ' }
                {getResultText(summary?.citySupervisor)}
                <br />
                {'Teléfono / Celular: ' }
                {getResultText(summary?.cellphoneNumberSupervisor)}
                <br />
                {'Correo electrónico: ' }
                {getResultText(summary?.emailSupervisor)}
                <br />
                {'Cargo del supervisor: ' }
                {getResultText(summary?.supervisorPosition)}
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <br />
              <Typography className={classes.subtitle}>Servicios contratados</Typography>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                {getServiceList()}
              </Grid>
            </Grid>
          </Paper>
        </Container>
      </Paper>
    </Container>
  );
};
const mapStateToProps = (props) => ({
  getInformationAgreementResponse: props.license.getInformationAgreementResponse,
  servicesCombo: props.service.servicesCombo,
  productType: props.home.productType,
  decodedToken: props.auth.decodedToken,
  gestorType: props.license.gestorType,
  listPaymentTypeContracts: props.license.listPaymentTypeContracts,
  statesAndCities: props.general.statesAndCities,
  documentTypes: props.general.documentTypes,
  listDocumentTypeContracts: props.license.listDocumentTypeContracts,
  listDeviceTypeContracts: props.license.listDeviceTypeContracts,
  listCredentialDeliveryContracts: props.license.listCredentialDeliveryContracts,
  listValidityTypeContracts: props.license.listValidityTypeContracts,
  riskOfficers: props.license.riskOfficers,
  riskOfficerRole: props.license.riskOfficerRole,
  applicationInfo: props.general.applicationInfo,
});
const mapDispatchToProps = {
  getInformationAgreement: getInformationAgreementAction,
  getServices: getServicesAction,
  getManagers: getManagersAction,
  getAppParametersContracts: getAppParametersContractsAction,
  getPurchaseOrderParameters: getPurchaseOrderParametersAction,
  getPackagesContracts: getPackagesContractsAction,
};
export default connect(mapStateToProps, mapDispatchToProps)(AgreementDetails);
